import { subscribeByID } from '@adornis/baseql/operations/mongo.js';
import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { ActionTokenData } from '@adornis/buchungsheld-db/entities/action.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { filter, map, switchMap } from 'rxjs';

@customElement('bh-page-confirm-mail')
export class BHPageConfirmMail extends BuchungsheldLitElement {
  @state() private readonly _actionID = new RXController(this, routingState.searchParams.get('action'));
  @state() private readonly _action = new RXController(
    this,
    this._actionID.observable.pipe(
      switchMap(async id => {
        if (!id) return null;
        const action = await ActionTokenData.getByID<ActionTokenData>(id)(ActionTokenData.allFields);
        return action;
      }),
    ),
  );
  @state() private readonly _confirmed = new RXController(
    this,
    this._action.observable.pipe(
      filter(Boolean),
      switchMap(action => subscribeByID(User, action.userID)({ emailConfirmed: 1 })),
      filter(Boolean),
      map(user => user.emailConfirmed),
    ),
  );

  // eslint-disable-next-line complexity
  override render() {
    if (this._actionID.isLoading || this._action.isLoading) return html` <tr-loader></tr-loader> `;
    if (!this._actionID.value)
      return html`
        <tr-card>
          <tr-h4 bold>${this._translation.translate('err', 'something_went_wrong')}</tr-h4>
          <tr-text>${this._translation.translate('err', 'could_not_process_data')}</tr-text>
          <tr-button href="/profile">${this._translation.translate('confirm_mail', 'to_profil')}</tr-button>
        </tr-card>
      `;
    if (!this._action.value?.isValid)
      return html` <x-flex>${this._translation.translate('confirm_mail', 'to_profil')}</x-flex> `;
    if (this._confirmed.value)
      return html`
        <tr-card>
          <tr-h4 bold>${this._translation.translate('confirm_mail', 'verify_success')}</tr-h4>
          <tr-text>${this._translation.translate('confirm_mail', 'verify_success_expl')}</tr-text>
          <tr-button href="/profile">${this._translation.translate('confirm_mail', 'to_profil')}</tr-button>
        </tr-card>
      `;

    return html`
      <x-flex>
        <x-card>
          <x-flex space="md">
            <x-h3>${this._translation.translate('confirm_mail', 'name')}</x-h3>
            <x-text>${this._translation.translate('confirm_mail', 'expl')}</x-text>
            <x-button
              @click=${async () => {
                if (!this._action.value) return;
                await User.useAction(this._action.value)();
              }}
            >
              ${this._translation.translate('approve')}
            </x-button>
          </x-flex>
        </x-card>
      </x-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          display: 'flex',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: this.fontFamily,
        },
      },
    ];
  }
}
